import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  ChangeDetectorRef,
  OnInit,
  OnDestroy,
  ChangeDetectionStrategy,
} from '@angular/core';
import { UiGridCommonService } from '@everymatrix-base-components/utils';

@Component({
  selector: 'dm-ui-grid-lib',
  template: '',
  styleUrl: './dm-ui-grid-lib.component.scss',
  standalone: true,
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DmUiGridLibComponent implements OnInit, OnChanges, OnDestroy {
  @Input() options: any; // Input property that will bind to the AngularJS grid options
  protected gridId: string;
  constructor(
    private cdr: ChangeDetectorRef,
    private uiGridCommonService: UiGridCommonService
  ) {
    this.gridId =
      this.uiGridCommonService.getUniqueIdForCouple('angular-component');
  }

  ngOnInit() {
    const couple = this.uiGridCommonService.getCoupleById(this.gridId);
    if (couple) {
      this.uiGridCommonService.setOptionsForId(this.gridId, this.options);
      this.cdr.detectChanges();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes['options'] &&
      changes['options'].currentValue !== changes['options'].previousValue
    ) {
      const couple = this.uiGridCommonService.getCoupleById(this.gridId);
      if (couple) {
        this.uiGridCommonService.setOptionsForId(this.gridId, this.options);
        this.cdr.detectChanges();
      }
    }
  }

  ngOnDestroy() {
    this.uiGridCommonService.removeCoupleById(this.gridId);
  }
}
